import React from 'react';
import PropTypes from 'prop-types';

import { getNameInitials } from 'utils/trimName';

const BusinessLogo = ({ name }) => {
  const nameInitials = getNameInitials(name);

  return (
    <div className="profile-image-box">
      <div className="business-logo">
        <span>{nameInitials}</span>
      </div>
    </div>
  );
};

BusinessLogo.defaultProps = {
  name: '',
};

BusinessLogo.propTypes = {
  name: PropTypes.string,
};

export default BusinessLogo;



// WEBPACK FOOTER //
// ./src/components/businessDetail/basicInfo/businessLogo.js